import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReadMoreProps } from "../interfaces/ReadMore";

const ReadMoreComponent: React.FC<ReadMoreProps> = ({ text, maxLength }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const displayText = isExpanded ? text : text.slice(0, maxLength);

  return (
    <div>
      <p className=" text-[#546E7A]">
        {displayText}
        {text.length > maxLength && (
          <span
            onClick={toggleReadMore}
            className="text-[#037897] font-semibold cursor-pointer"
          >
            {isExpanded ? ` ${t("common.readLess", "Read Less")}` : ` ${t("common.readMore", "Read More")}`}
          </span>
        )}
      </p>
    </div>
  );
};

export default ReadMoreComponent;
